class calendarBlock {
    constructor() {

        let calendarBlockEl = document.getElementById('pollen-calendar-allergens-block');
        if (!calendarBlockEl) {
            return;
        }
        this.init();
    };

    async init() {
        let data = await this.fetchCalendarData();
        // for (let dataitem in data) {
        //     var i = Object.keys(data).indexOf(dataitem)+1;
        //     console.log(i);
        //     console.log(dataitem);
            
        //     // if(dataitem == 'south_central'){
        //     console.log(data[dataitem]);

            // var topcheckboxArr = [];
            // let hdmStaticData = {
            //     "low": [
            //       {
            //         "end": 48,
            //         "start": 1
            //       }
            //     ],
            //     "name": "HDM",
            //     "type": "hdm"                
            // };
            // data.push(hdmStaticData);
            data.forEach( item => {
                console.log(item);
                let itemName = item.name.replaceAll(' ', '-');
                let itemNameTranslated = this.getTranslation(itemName);
                let itemType = item.type.toLowerCase();
                let sesionLowcolore, sesionMidcolore, sesionHighcolore = '';

                switch (itemType) {
                case 'tree':
                    sesionLowcolore = '#E3EDC5';
                    sesionMidcolore = '#42C8A0';
                    sesionHighcolore = '#A9C23E';
                    break;
                case 'grass':
                    sesionLowcolore = '#D0EAC5';
                    sesionMidcolore = '#B7B39E';
                    sesionHighcolore = '#5E8954';
                    break;
                case 'weed':
                    sesionLowcolore = '#D1DCCF';
                    sesionMidcolore = '#60A9A2';
                    sesionHighcolore = '#7D998F';
                    break;
                case 'hdm':
                    sesionLowcolore = '#98C2E5';
                    sesionMidcolore = '#96BC56';
                    sesionHighcolore = '#445626';
                    break;
                case 'animal':
                    sesionLowcolore = '#C7DFA0';
                    sesionMidcolore = '#96BC56';
                    sesionHighcolore = '#445626';
                break;

                }

                var lowJson = '';
                if(item['low']){
                    lowJson = JSON.stringify(item['low']);
                }
                var highJson = '';
                if(item['high']){
                    highJson = JSON.stringify(item['high']);
                }

                document.getElementById('pollen-season__allergens-periods-wrapper').innerHTML += `
                <div class="allergen__type--0 d-flex flex-column flex-md-row pollen-season__allergen ${itemType}-allergen w-100 list-pollen-${itemName}">
                        <span class="align-items-center d-flex pe-2 pe-lg-3 pollen-season__allergen--name ${itemType}-allergen text-start"><span class="me-lg-2 me-1 d-inline-block rounded-pill"></span>${itemNameTranslated}</span>
                        <span class="flex-fill pollen-season__allergen--periods position-relative w-100">                        
                        ${this._creatHtml(`${itemType}-low-season`,`${lowJson}`, sesionLowcolore)}
                        ${this._creatHtml(`${itemType}-high-season`,`${highJson}`, sesionHighcolore)}
                        </span>
                    </div>
                `
            });

            let checkboxes = document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]');
            checkboxes.forEach( checkbox => {
                checkbox.addEventListener( 'change' , event => {                      
                    event.preventDefault();
                    document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show .pollen-season__allergen').forEach( ListEl => { 
                        ListEl.classList.add('d-none'); 
                        ListEl.classList.remove('d-flex'); 
                    });
                    if (document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]:checked').length > 0) {
                        document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]:checked').forEach( checkedEl => {
                            document.querySelectorAll(`.pollen-season__allergens-periods-wrapper.show .pollen-season__allergen.${checkedEl.value}-allergen`).forEach( ListEl =>{ 
                                ListEl.classList.remove('d-none'); 
                                ListEl.classList.add('d-flex'); 
                            });

                        });
                        if(document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]:checked').length < 4){
                            document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show').forEach( ListEl => { 
                            ListEl.classList.add('checked-allergen'); 
                            });
                        }
                        else{
                            document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show').forEach( ListEl => { 
                            ListEl.classList.remove('checked-allergen'); 
                            });
                        }
                    }
                    else {
                        document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show .pollen-season__allergen').forEach( ListEl => { 
                            ListEl.classList.remove('d-none'); 
                            ListEl.classList.add('d-flex'); 
                        });
                        document.querySelectorAll('.pollen-season__allergens-periods-wrapper.show').forEach( ListEl => { 
                            ListEl.classList.remove('checked-allergen'); 
                        });
                    }                
                });
            });
            // }
        // }

        // let regTabs = document.querySelectorAll('[data-regtab]');
        // regTabs.forEach( regTab => {
        //     regTab.addEventListener( 'click' , event => {                 
        //     var regTabVal = regTab.getAttribute('data-regtab');
        //     document.querySelectorAll('[data-regtab]').forEach( ListEl => { 
        //         ListEl.classList.remove('active'); 
        //     });
        //     document.querySelectorAll(`[data-regtab=${regTabVal}]`).forEach( ListEl =>{ 
        //         ListEl.classList.add('active'); 
        //     });
        //     document.querySelectorAll('.pollen-season__allergens-periods-wrapper').forEach( ListEl => { 
        //         ListEl.classList.add('d-none'); 
        //         ListEl.classList.remove('show'); 

        //         ListEl.classList.remove('checked-allergen'); 
        //     });
        //     document.querySelectorAll(`#pollen-season__allergens-periods-wrapper_${regTabVal}`).forEach( ListEl =>{ 
        //         ListEl.classList.remove('d-none'); 
        //         ListEl.classList.add('show'); 
        //     });

        //     document.querySelectorAll('.pollen-season__chart-legend input[type="checkbox"]').forEach( checkbox => {
        //         checkbox.checked = false;
        //     });
        //     document.querySelectorAll('.pollen-season__allergens-periods-wrapper .pollen-season__allergen').forEach( ListEl => { 
        //         ListEl.classList.remove('d-none'); 
        //         ListEl.classList.add('d-flex'); 
        //     });
        //     });
        // });        
    };

    
    _creatHtml(className,arr, color){
        let html=``;
        if(arr != ''){
            arr=JSON.parse(arr);
            arr.forEach(a_width => {
                let left = (((((a_width.start) - 1 ) / 48.0 ) * 100 )).toFixed(2);
                let width = (((a_width.end/48.0) * 100 ).toFixed(2)) - left;
                let tempHtml=`<span class="period low-season position-absolute ${className}" style="left:${left}%; width: ${width}%; background: ${color};"></span>`;
                html+=tempHtml
            });
        }
        return html;
    }

    async fetchCalendarData() {
        let data = [];
        await  fetch(`https://alk-app.klarify.me/api/pollen-calendar/allergens`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${window.klarifyAppToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
        .then(async (response) => {
            data.push(response.data.data);
        });

        return await data[0];
        
    }

    getTranslation(text) {
        this.curLang = localStorage.selectedLanguage;
        try {
            switch (text) {
                case 'Hazel':
                    return (this.curLang == 'de' ? 'Haselnuss' : this.curLang == 'fr' ? 'Noisetier' : this.curLang == 'it' ? 'Nocciolo' : 'Haselnuss');
                    break;
                case 'Alder':
                    return (this.curLang == 'de' ? 'Erle' : this.curLang == 'fr' ? 'Aulne' : this.curLang == 'it' ? 'Ontano' : 'Erle');
                    break;
                case 'Ash':
                    return (this.curLang == 'de' ? 'Esche' : this.curLang == 'fr' ? 'Frêne' : this.curLang == 'it' ? 'Frassino' : 'Esche');
                    break;
                case 'Birch':
                    return (this.curLang == 'de' ? 'Birke' : this.curLang == 'fr' ? 'Bouleau' : this.curLang == 'it' ? 'Betulla' : 'Birke');
                    break;
                case 'Hornbeam':
                    return (this.curLang == 'de' ? 'Hainbuche' : this.curLang == 'fr' ? 'Charme' : this.curLang == 'it' ? 'Carpino' : 'Hainbuche');
                    break;
                case 'Oak':
                    return (this.curLang == 'de' ? 'Eiche' : this.curLang == 'fr' ? 'Chêne' : this.curLang == 'it' ? 'Quercia' : 'Eiche');
                    break;
                case 'SweetChestnut':
                    return (this.curLang == 'de' ? 'Süße Kastanie' : this.curLang == 'fr' ? 'Châtaigne' : this.curLang == 'it' ? 'Dolce castagna' : 'Süße kastanie');
                    break;
                case 'Grass':
                    return (this.curLang == 'de' ? 'Gräser' : this.curLang == 'fr' ? 'Graminées' : this.curLang == 'it' ? 'Piante erbacee' : 'Gräser');
                    break;
                case 'Dock':
                    return (this.curLang == 'de' ? 'Ampfer' : this.curLang == 'fr' ? 'Oseille' : this.curLang == 'it' ? 'Acetosa' : 'Ampfer');
                    break;
                case 'Plantain':
                    return (this.curLang == 'de' ? 'Wegerich' : this.curLang == 'fr' ? 'Banane plantain' : this.curLang == 'it' ? 'Piantaggine' : 'Wegerich');
                    break;
                case 'Mugwort':
                    return (this.curLang == 'de' ? 'Beifuß' : this.curLang == 'fr' ? 'Armoise' : this.curLang == 'it' ? 'Artemisia comune' : 'Beifuß');
                    break;
                case 'Ambrosia':
                    return (this.curLang == 'de' ? 'Ambrosia' : this.curLang == 'fr' ? 'Ambroisie' : this.curLang == 'it' ? 'Ambrosia' : 'Ambrosia');
                    break;
                case 'HDM':
                    return (this.curLang == 'de' ? 'Hausstaubmilben' : this.curLang == 'fr' ? 'Acariens' : this.curLang == 'it' ? 'Acari della polvere' : 'Ambrosia');
                    break;
            }

        } catch (e) {
            console.error(e);
        }
    }
}

typeof calendarBlock !== 'undefined' && new calendarBlock();
